import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import useWindowSize from 'hooks/useWindowSize';
import useOutsideClickHandler from 'hooks/useOutsideClickHandler';
import { ReactComponent as InfoIcon } from 'products/nomad_insurance/assets/img/icons/info.svg';
import { SCREEN_SIZES } from 'style';
import TooltipBox from '../TooltipBox';
import { IconContainer } from './styled';

// this is how close to the edge the definition tooltip is allowed
// to go, in px
const X_BOUND = 20;

const Tooltip = ({ children, variant, className }) => {
  const tooltipBoxRef = useRef();
  const [showTooltip, setShowTooltip] = useState(false);
  const { width: windowWidth } = useWindowSize();
  const ref = useRef();
  useOutsideClickHandler(ref, () => setShowTooltip(false));

  const handleHover = () => {
    if (windowWidth < SCREEN_SIZES.desktop) return;
    setShowTooltip(!showTooltip);
  };

  useEffect(() => {
    if (!showTooltip || !tooltipBoxRef.current) {
      return;
    }
    tooltipBoxRef.current.style.transform = '';
    const tooltipBoxRect = tooltipBoxRef.current.getBoundingClientRect();

    if (tooltipBoxRect.left < X_BOUND) {
      tooltipBoxRef.current.style.transform = `translateX(${
        X_BOUND - tooltipBoxRect.left
      }px)`;
    }

    if (tooltipBoxRect.right > window.innerWidth - X_BOUND) {
      tooltipBoxRef.current.style.transform = `translateX(-${
        tooltipBoxRect.right - window.innerWidth + X_BOUND
      }px)`;
    }
  }, [showTooltip]);

  return (
    <IconContainer ref={ref} className={className}>
      <InfoIcon
        onMouseEnter={handleHover}
        onMouseLeave={handleHover}
        onClick={() => {
          if (windowWidth >= SCREEN_SIZES.desktop) return;
          setShowTooltip(true);
        }}
      />
      <TooltipBox ref={tooltipBoxRef} showTooltip={showTooltip} variant={variant}>
        {children}
      </TooltipBox>
    </IconContainer>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'wide'])
};

export default Tooltip;
